import { useEffect, useState } from "react";
import Contact from "../components/Contact";
import Navigation from "../components/Navigation";
import useTitle from "@nooks/use-title";
import { authService } from "../fbase";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from "firebase/auth"
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

function SignIn(){
    const navigate = useNavigate()
    useTitle("캐리빌리 로그인")
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [newAccount, setNewAccount] = useState(false);
    const [error, setError] = useState("");
    const onChange = (event) => {
        const { target : {name, value}} = event;
        if(name === "email"){
            setEmail(value);
        } else if(name==="password"){
            setPassword(value);
        } else if(name==="passwordConfirm"){
            setPasswordConfirm(value);
        }
    }
    const onSubmit = async(event) => {
        event.preventDefault();
        try{
            let data;
            const auth = getAuth();
            if(newAccount){
                if(password === passwordConfirm){
                    data = await createUserWithEmailAndPassword(
                        auth, email, password
                    );
                } else {
                    return swal("비밀번호를 확인해주세요!", "", "error")
                }
            } else {
                data = await signInWithEmailAndPassword(auth, email, password);
            }
            navigate("/", {replace:true})
        } catch(error) {
            switch (error.code) {
                case "auth/user-not-found" || "auth/wrong-password":
                    return setError("이메일 혹은 비밀번호가 일치하지 않습니다.")
                case "auth/email-already-in-use":
                    return setError("이미 사용 중인 이메일입니다.");
                case "auth/weak-password":
                    return setError("비밀번호는 6글자 이상이어야 합니다.");
                case "auth/network-request-failed":
                    return setError("네트워크 연결에 실패 하였습니다.");
                case "auth/invalid-email":
                    return setError("잘못된 이메일 형식입니다.");
                case "auth/internal-error":
                    return setError("잘못된 요청입니다.");
                default:
                    return setError("로그인에 실패 하였습니다.");
            }
        }
    }
    const toggleAccount = () => setNewAccount((prev) => !prev)
    const onSocialClick = async (event) => {
        const {target:{name}} = event;
        let provider;
        if(name === "google"){
            provider = new GoogleAuthProvider()
        }
        const data = await signInWithPopup(authService, provider)
        console.log(data)
        navigate("/", {replace:true})
    }
    return (
        <div>
            <Navigation />
            <section className="page-section" id="signin">
                <div className="container">
                    <div className="text-center">
                        <h2 className="section-heading text-uppercase">Sign In</h2>
                    </div>
                    <div className="row text-center">
                        <form onSubmit={onSubmit}>
                            <input type="text" name="email" onChange={onChange} placeholder="email" value={email} required />
                            <br />
                            <input type="password" name="password" onChange={onChange} placeholder="비밀번호" value={password} required />
                            <br />
                            {newAccount ?
                                <>
                                    <input type="password" name="passwordConfirm" onChange={onChange} placeholder="비밀번호 확인" value={passwordConfirm} required />
                                    <br />
                                </>
                                :
                                null
                            }
                            <input type="submit" value={newAccount ? "회원가입" : "로그인"} className="btn btn-primary btn-xl" />
                            <div>{error}</div>
                        </form>
                        <div>
                            <input type="button" onClick={toggleAccount} value={newAccount ? "로그인" : "회원가입"} className="btn btn-primary btn-xl" />
                            <input type="button" onClick={onSocialClick} name="google" value="구글 로그인" className="btn btn-primary btn-xl" />
                        </div>
                    </div>
                </div>
            </section>
            <Contact />
        </div>
    )
}

export default SignIn;